
<template>
  <div class="wrap-black text-center">
    <div class="container">
      <div v-if="valid">
        <form method="post" v-on:submit.prevent="submit" class="form-pub">
          <p class="xs-pb-20">
            Reset Password.<br />
            Enter a new password below.
          </p>
          <div class="form-group">
            <input v-model="credentials.password" name="password" class="form-control" type="password" placeholder="Password" autocomplete="off" required="required">
          </div>
          <div class="form-group">
            <input v-model="credentials.confirmPassword" name="password" class="form-control" type="password" placeholder="Confirm Password" autocomplete="off" required="required">
          </div>
          <div v-if="currentUser.errors">
            <div v-for="msg in currentUser.errors" role="alert" class="alert alert-contrast alert-danger alert-dismissible">
              <div class="message">{{msg}}</div>
            </div>
          </div>

          <div class="form-group xs-pt-10">
            <button class="btn-pub btn-pub-primary btn-pub-borderless fixed-width" :disabled="!credentials.password || !credentials.confirmPassword || saving">{{saving ? 'Please wait...' : 'Submit'}}</button>
          </div>
        </form>
      </div>
      <div v-else>
        <div class="panel-body">
          <div role="alert" class="alert alert-contrast alert-danger alert-dismissible">
            <div class="message">Invalid password reset link</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
  import { mapState } from 'vuex'

export default {

  created() {
    this.$store.commit(`CLEAR_USER_ERRORS`);
  },

  methods: {
    submit() {
      this.$store.commit(`CLEAR_USER_ERRORS`);
      this.saving = true;
      var self = this;

      let payload = {
        credentials: {
          password: this.credentials.password,
          password_confirmation: this.credentials.confirmPassword,
        },
        accessToken: this.accessToken,
        clientId: this.clientId,
        uid: this.uid,
        callback: function (errors) {
          self.saving = false;
        }
      }

      this.$store.dispatch('resetPassword', payload);
    },
  },

  computed: {
    ...mapState([
      'currentUser'
    ]),
    accessToken() {
      const urlParams = new URLSearchParams(window.location.search);
      const myParam = urlParams.get('access-token');
      return myParam;
    },
    clientId() {
      const urlParams = new URLSearchParams(window.location.search);
      const myParam = urlParams.get('client_id');
      return myParam;
    },
    uid() {
      const urlParams = new URLSearchParams(window.location.search);
      const myParam = urlParams.get('uid');
      return myParam;
    },
    valid() {
      if (!this.accessToken || !this.clientId || !this.uid) {
        return false;
      }
      return true;
    },
  },

  data() {
    return {
      credentials: {
        password: null,
        confirmPassword: null,
      },
      saving: false,
    }
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  p { font-size: 18px; line-height: 24px; }
  form { max-width: 460px; margin: 0px auto; }

  @media (max-width: 767px) {
    .wrap-black { padding: 40px 20px; }
  }
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?a850967e